
<template>

	<div/>

</template>

<script>


import api from "../api"

export default
{
	components :
	{
	},

	data()
	{
		return {

		}
	},

	beforeMount() 
	{
		return api.load_roles(this, true)
	},

	methods :
	{
	}
}

</script>

